import * as React from 'react';
import moment from 'moment';
import { Box, Typography, List, ListItem, IconButton } from '@mui/material';
import MuiBadge from '@mui/material/Badge';
import { CompanyCertification } from '../../interfaces/users.interface';
import { Assistant } from '@mui/icons-material';

type Props = {
  companyCerts: CompanyCertification[];
  onShowAutoAnsweredByCert: (cert: CompanyCertification) => void;
};

export default function CompanyCertsList({
  companyCerts,
  onShowAutoAnsweredByCert,
}: Props) {
  if (!companyCerts?.length) return null;

  const GRID = '1fr 80px 120px';

  return (
    <>
      {/* Header */}
      <Typography
        component="div"
        sx={{
          px: 2,
          display: 'grid',
          gridTemplateColumns: GRID,
          alignItems: 'center',
          columnGap: 2,
        }}
      >
        <Box>Certifications</Box>
        <Box sx={{ textAlign: 'right' }}>End Date</Box>
        <Box sx={{ textAlign: 'right' }}>Auto-Answered</Box>
      </Typography>
      <List>
        {companyCerts.map((cert) => {
          const autoCount =
            (cert as any)?.autoAnsweredCount ??
            (cert as any)?.autoAnswered?.length ??
            0;

          const title =
            typeof cert.certification === 'object'
              ? cert.certification.title
              : String(cert.certification);

          return (
            <ListItem key={cert.id}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: GRID,
                  alignItems: 'center',
                  width: '100%',
                  columnGap: 2,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                  <Box
                    component="a"
                    href={cert.document}
                    target="_blank"
                    rel="noreferrer"
                    title={title}
                    sx={{
                      color: 'primary.main',
                      textDecoration: 'none',
                      '&:hover': { textDecoration: 'underline' },
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {title}
                  </Box>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                  {moment(cert.expirationDate).format('MM/DD/YYYY')}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1 }}>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onShowAutoAnsweredByCert(cert);
                    }}
                    aria-label="View auto-answered by this certification"
                  >
                    <MuiBadge
                      color="primary"
                      badgeContent={autoCount}
                      invisible={autoCount <= 0}
                      overlap="circular"
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                      <Assistant
                        fontSize="small"
                        sx={{ color: (t) => t.palette.text.secondary }}
                      />
                    </MuiBadge>
                  </IconButton>
                </Box>
              </Box>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}
